import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Container, Typography } from '@mui/material';

/**
 * Redirects React routes to the pre-rendered static HTML versions in /public/articles.
 * Keeps router definitions while letting the server serve the static files for SEO.
 */
const StaticArticleRedirect = ({ detail = false }) => {
  const { slug } = useParams();

  useEffect(() => {
    const target = detail && slug ? `/articles/${slug}/` : '/articles/index.html';
    window.location.replace(target);
  }, [detail, slug]);

  return (
    <Container sx={{ mt: 10, textAlign: 'center' }}>
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
        <CircularProgress size={24} />
        <Typography variant="body1" color="text.secondary">
          Loading articles…
        </Typography>
      </Box>
    </Container>
  );
};

export default StaticArticleRedirect;
